import * as React from 'react';
import Customer, { RootCustomer } from '../../models/be/Customer';
import CheckType from '../../models/CheckType';
import Package, { PackageNames } from '../../models/be/Package';

export interface CustomerContext {
	rootCustomer: ContextStore<RootCustomer>;
	clientCustomer: ContextStore<Customer>;
	customer: ContextStore<Customer>;
	workflowTypes: ContextStore<CheckType[]>;
	selectedCustomerId: number;
	packages: PackageNames[];
	packageList: ContextStore<Package[]>;
	resetContext: () => Promise<void>;
}

const defaultCustomerContext: CustomerContext = {
	rootCustomer: {} as ContextStore<RootCustomer>,
	clientCustomer: {} as ContextStore<Customer>,
	customer: {} as ContextStore<Customer>,
	workflowTypes: {} as ContextStore<CheckType[]>,
	packages: [] as PackageNames[],
	packageList: {} as ContextStore<Package[]>,
	selectedCustomerId: null,
	resetContext: async () => {}
};

export const customerContext = React.createContext<CustomerContext>(defaultCustomerContext);

export interface ContextStore<T> {
	value: T;
	setValue: ((key: keyof T, value: string) => void) | ((setValue: T) => void);
}
